import { ButtonMetadata } from 'components/buttons/button-types';
import { Util } from 'utils/common.utils';

const t = (name: string, section: string) => {
  const meta: ButtonMetadata = {
    componentName: name,
    areaName: section,
  };

  return meta;
};

const ev = (event: string, context: string) => {
  return {
    event,
    context,
    page_url: Util.CurrentLocation(),
  }
};

const tracking = {
  manage: {
    changeCard: {
      editIcon: t('payment card edit icon', 'manage recurring payment'),
      confirm: {
        cancel: t('replace card popup', 'recurring payment - replace card confirmation'),
        confirm: t('replace card popup', 'recurring payment - replace card confirmation'),
      },
      failure: {
        back: t('card update failure action', 'card update failed screen'),
        retry: t('card update failure action', 'card update failed screen'),
      },
      successEvent: ev('recurring payment success', 'change card'),
      failureEvent: ev('recurring payment failure', 'change card'),
    },
    cancel: {
      yes: t('cancel recurring payment popup', 'manage recurring payment - cancel recurring payment confirmation'),
      no: t('cancel recurring payment popup', 'manage recurring payment - cancel recurring payment confirmation'),
      successEvent: ev('recurring payment success', 'recurring payment setup cancelled'),
      failureEvent: ev('recurring payment failure', 'cancel recurring payment setup failure'),
    },
    changePaymentDateDialog: {
      cancel: t('change payment date popup', 'manage recurring payment - change payment date details'),
      chatToAgent: t('change payment date popup', 'manage recurring payment - change payment date details'),
    },
    cancelRecurringPayment: t('cancel recurring payment model', 'manage recurring payment - change payment date details'),
    back: t('recurring payment details card', 'manage recurring payment - change payment date details'),
    changePaymentDate: t('recurring payment details card', 'manage recurring payment - change payment date details'),
  },
  amountToPay: {
    setupReminder: t('bottom sidebar navigation', 'payment reminder panel'),
    setup: t('account details card', 'my account - total amount to pay - [amountToPay]'),
    manage: t('manage recurring payment card', 'my account section'),
  },
  setup: {
    intro: {
      back: t('recurring payment details card', 'recurring payment details rules list'),
      setup: t('recurring payment details card', 'recurring payment details rules list'),
    },
    confirmDialog: {
      cancel: t('setup recurrent payment confirmation popup', 'setup recurring payment [dayOrdinal] every month'),
      addCard: t('setup recurrent payment confirmation popup', 'setup recurring payment [dayOrdinal] every month'),
      successEvent: {
        ...ev('recurring_payment_success', 'setup recurring payment'),
        service_name: 'setup - [dayOrdinal] of every month',
      }
    }
  }
};

export default tracking;